const BASE_URL = process.env.REACT_APP_API_URL;

function getToken() {
    return localStorage.getItem("d_c_c_t");
}


async function getCsrfToken() {
  const response = await fetch(`${BASE_URL}/csrf/token`, { method: "GET", credentials: "include" });
  const data = await response.json();
  return data.csrfToken;
}



export async function getStandards() {
  try {
      const token = getToken();
      

      const headers = {
          "Content-Type": "application/json",
         ...(token ? { Authorization: `Bearer ${token}` } : {}),
         
      };
      const response = await fetch(`${BASE_URL}/control-references`, {
          method: "GET",
          headers,
      });

    

      const data = await response.json();
      if (!response.ok || !data.success) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          throw new Error("Failed to fetch");
      }
      return data;
  } catch (error: any) {
      throw new Error(error);
  }
}


export async function getReferences(query: string, perPage: number, pageNo: number) {
  try {

      const token = getToken();
      //const csrfToken = await getCsrfToken();

      const headers = {
          "Content-Type": "application/json",
         ...(token ? { Authorization: `Bearer ${token}` } : {}),
        //  'X-CSRF-TOKEN': csrfToken,
      };
      const response = await fetch(`${BASE_URL}/control-references?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
          method: "GET",
          headers,
          // credentials: "include",
      });

    

      const data = await response.json();
      if (!response.ok || !data.success) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          //console.log("Failed to fetch");
      }
      return data;
  } catch (error: any) {
      //console.log(error);
  }
}


export async function getReferencesInCompliance(query: string, perPage: number, pageNo: number) {
  try {

      const token = getToken();
      //const csrfToken = await getCsrfToken();

      const headers = {
          "Content-Type": "application/json",
         ...(token ? { Authorization: `Bearer ${token}` } : {}),
        //  'X-CSRF-TOKEN': csrfToken,
      };
      const response = await fetch(`${BASE_URL}/control-references/in-compliance?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
          method: "GET",
          headers,
          // credentials: "include",
      });

    

      const data = await response.json();
      if (!response.ok || !data.success) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          //console.log("Failed to fetch");
      }
      return data;
  } catch (error: any) {
      //console.log(error);
  }
}


export async function getCoso(){
    try {
       // //const csrfToken = await getCsrfToken();
       const token = getToken();
        const headers = {
            "Content-Type": "application/json",
           ...(token ? { Authorization: `Bearer ${token}` } : {}),
           // "X-CSRF-TOKEN": csrfToken,
        };
      const response = await fetch(`${BASE_URL}/coso`,{method:"GET",headers});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
    
}

export async function getCobit(){
    try {

      console.log("cobit");
       // //const csrfToken = await getCsrfToken();
       const token = getToken();
        const headers = {
            "Content-Type": "application/json",
           ...(token ? { Authorization: `Bearer ${token}` } : {}),
           // "X-CSRF-TOKEN": csrfToken,
        };
      const response = await fetch(`${BASE_URL}/cobit`,{method:"GET",headers});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
    
}


export async function getCBE(){
    try {
       // //const csrfToken = await getCsrfToken();
       const token = getToken();
        const headers = {
            "Content-Type": "application/json",
           ...(token ? { Authorization: `Bearer ${token}` } : {}),
           // "X-CSRF-TOKEN": csrfToken,
        };
      const response = await fetch(`${BASE_URL}/cbe-function`,{method:"GET",headers});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
    
}


export async function getNIST(){
    try {
       // //const csrfToken = await getCsrfToken();
       const token = getToken();
        const headers = {
            "Content-Type": "application/json",
           ...(token ? { Authorization: `Bearer ${token}` } : {}),
           // "X-CSRF-TOKEN": csrfToken,
        };
      const response = await fetch(`${BASE_URL}/nist`,{method:"GET",headers});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
    
}


export async function getISO(){
    try {
       // //const csrfToken = await getCsrfToken();
       const token = getToken();
        const headers = {
            "Content-Type": "application/json",
           ...(token ? { Authorization: `Bearer ${token}` } : {}),
           // "X-CSRF-TOKEN": csrfToken,
        };
      const response = await fetch(`${BASE_URL}/iso`,{method:"GET",headers});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
    
}

export async function getControlByCBE(id: any) {
    try {
      const token = getToken();
        const headers = {
            "Content-Type": "application/json",
           ...(token ? { Authorization: `Bearer ${token}` } : {}),

        };
        const response = await fetch(`${BASE_URL}/control-cbe/by-cbe?cbe_id=${id}`, { method: "GET", headers });
        if (!response.ok) {
            throw new Error('Failed to fetch data');
        }
        return response.json();
    } catch (error) {
        throw new Error('Failed to fetch data');
    }
}

export async function getControlByISO(id:any){
    try {
      const token = getToken();

      const headers = {
        "Content-Type": "application/json",
       ...(token ? { Authorization: `Bearer ${token}` } : {}),
       // "X-CSRF-TOKEN": csrfToken,
    };

      const response = await fetch(`${BASE_URL}/control-iso/${id}`,{method:"GET",headers});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();

    } catch (error) {
      throw new Error('Failed to fetch data');
    }
}


export async function getControlByCobit(id:any){
    try {
      const token = getToken();
      const headers = {
        "Content-Type": "application/json",
       ...(token ? { Authorization: `Bearer ${token}` } : {}),
       // "X-CSRF-TOKEN": csrfToken,
    };

      const response = await fetch(`${BASE_URL}/control-cobit/${id}`,{method:"GET",headers});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();

    } catch (error) {
      throw new Error('Failed to fetch data');
    }
} 


export async function getControlByCoso(id:any){
    try {
      const token = getToken();
      const headers = {
        "Content-Type": "application/json",
       ...(token ? { Authorization: `Bearer ${token}` } : {}),
       // "X-CSRF-TOKEN": csrfToken,
    };  

      const response = await fetch(`${BASE_URL}/control-coso/${id}`,{method:"GET",headers});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();

    } catch (error) {
        throw new Error('Failed to fetch data');
    }
}

export async function getControlByNist(id:any){
    try {
      const token = getToken();
      const headers = {
        "Content-Type": "application/json",
       ...(token ? { Authorization: `Bearer ${token}` } : {}),
       // "X-CSRF-TOKEN": csrfToken,
    };

      const response = await fetch(`${BASE_URL}/control-nist/${id}`,{method:"GET",headers});
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
} 


export async function uploadExcel(file: File) {
    try {
        const formData = new FormData();
        formData.append('file', file);

        // Do not set 'Content-Type' when using FormData
        const headers = {
            // "Content-Type": "multipart/form-data", // Remove this line
        };

        const response = await fetch(`${BASE_URL}/domain/upload-template`, {
            method: "POST",
            body: formData,
            headers,
        });

        if (!response.ok) {
            throw new Error('Failed to upload Excel file');
        }

        return response.json();
    } catch (error) {
        throw new Error('Failed to upload Excel file');
    }
}


export async function updateStandards(id: any, title: string) {
    try {
      const token = getToken();
        
       let controlReferenceData={ name: title } 
        const response = await fetch(`${BASE_URL}/control-references/${id}`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
       ...(token ? { Authorization: `Bearer ${token}` } : {}),

            },
            body: JSON.stringify(controlReferenceData),
        });
        return response.json();
    } catch (error) {
        throw new Error('Failed to update standards');
    }
}

export async function updateDomain(id: any, enName: string, arName: string) {
     try {
        
        let controlReferenceData={ en_name: enName, ar_name: arName } 
       const response = await fetch(`${BASE_URL}/domain/${id}`, {
           method: "PATCH",
           headers: {
               "Content-Type": "application/json",
           },
           body: JSON.stringify(controlReferenceData),
       });
       return response.json();
   } catch (error) {
       throw new Error('Failed to update standards');
   }
}
